import React from 'react';

import Aux from '../../hoc/Auxiliary';

import classes from './BlogEntry.module.css';

const blogEntry = props => {
    let entry = null;
    if (props.loaded) {
        entry = (
            <Aux>
                <h1>{props.entry.title.rendered}</h1>
                <div dangerouslySetInnerHTML={{ __html: props.entry.content.rendered }} />
            </Aux>);
    }
    return (
        <div className={classes.Entry}>
            {entry}
        </div>
    );
}



export default blogEntry;